import { MessageInterface } from "../interface/Message.interface";

export class Message implements MessageInterface {
    uuid: string;
    senderUuid: string;
    senderName: string;
    recipientUuid: string;
    recipientName: string;
    content: string;
    projectUuid?: string;
    projectName?: string;
    isRead: boolean;
    createdAt: string;
    formattedDate?: string;

    constructor(params: MessageInterface) {
        this.uuid = params.uuid;
        this.senderUuid = params.senderUuid;
        this.senderName = params.senderName;
        this.recipientUuid = params.recipientUuid;
        this.recipientName = params.recipientName;
        this.content = params.content;
        this.projectUuid = params.projectUuid;
        this.projectName = params.projectName;
        this.isRead = params.isRead;
        this.createdAt = params.createdAt;
        this.formattedDate = params.formattedDate;
    }

    isSentBy(userUuid: string): boolean {
        return this.senderUuid === userUuid;
    }

    getFormattedDate(): string {
        if (this.formattedDate) return this.formattedDate;

        const date = new Date(this.createdAt);
        const now = new Date();
        const isToday = date.toDateString() === now.toDateString();

        if (isToday) {
            return date.toLocaleTimeString('fr-FR', {
                hour: '2-digit',
                minute: '2-digit'
            });
        }

        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    // Timestamp relatif ("Il y a 2 min", "Il y a 1h", etc.)
    getRelativeTime(): string {
        const date = new Date(this.createdAt);
        const now = new Date();
        const diffMs = now.getTime() - date.getTime();
        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHour = Math.floor(diffMin / 60);
        const diffDay = Math.floor(diffHour / 24);

        if (diffSec < 60) return "À l'instant";
        if (diffMin < 60) return `Il y a ${diffMin} min`;
        if (diffHour < 24) return `Il y a ${diffHour}h`;
        if (diffDay === 1) return "Hier";
        if (diffDay < 7) return `Il y a ${diffDay} jours`;

        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: 'short'
        });
    }

    // Pour les séparateurs de date
    getDateGroup(): string {
        const date = new Date(this.createdAt);
        const now = new Date();
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);

        if (date.toDateString() === now.toDateString()) {
            return "Aujourd'hui";
        }
        if (date.toDateString() === yesterday.toDateString()) {
            return "Hier";
        }

        const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
        if (diffDays < 7) {
            return date.toLocaleDateString('fr-FR', { weekday: 'long' });
        }

        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: 'long',
            year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    }

    // Heure simple pour affichage dans les bulles
    getTime(): string {
        const date = new Date(this.createdAt);
        return date.toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    getMessageId(): string {
        return this.uuid;
    }

    // Initiales du sender pour l'avatar
    getSenderInitials(): string {
        return this.senderName
            .split(' ')
            .map(n => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    }
}
